import { Stack, type StackProps } from '@adc/parallax-component-library';

import { NavigationMenu } from './navigation/NavigationMenu';

export const PageContainer = ({ children, ...props }: StackProps) => (
  <Stack
    flex={1}
    backgroundColor="$surface.brand"
    testID="container"
    {...props}
  >
    <Stack
      flex={1}
      flexDirection="row"
      backgroundColor="$surface.background"
      borderTopLeftRadius="$2"
      borderTopRightRadius="$2"
      overflow="hidden"
    >
      <NavigationMenu />
      <Stack
        flex={1}
        marginHorizontal="$6"
        marginVertical="$8"
        overflow="visible"
      >
        {children}
      </Stack>
    </Stack>
  </Stack>
);
